import { defineProductConfig, } from "./product-config.js";
import productIdentity from "./product-identity.json" with { type: "json" };
const vlaApplicationName = productIdentity.products.vla.applicationName;
const westernApplicationName = productIdentity.products.western.applicationName;
const sharedFeatures = {
    workbench: true,
    projectManagement: true,
    annotationConfiguration: true,
    teamMembers: true,
    operationConsole: true,
};
const sharedMenuKeys = [
    "workbench",
    "project-management",
    "annotation-configuration",
    "team-members",
];
const westernMenuKeys = [
    "workbench",
    "project-management",
    "model-management",
    "config-management",
    "training-center",
    "team-members",
];
const sharedLoginPresentation = {
    loginEyebrow: "西部创源",
    loginHeading: "欢迎登录",
    loginDescription: "培训与数据标注全流程协同",
    loginHighlights: ["数据闭环", "多角色协同", "全流程质控"],
    loginPartnerMarks: [],
    copyright: "© 2026 西部创源 All Rights Reserved",
};
export const vlaProductConfig = defineProductConfig({
    code: "vla",
    brand: {
        applicationName: vlaApplicationName,
        platformName: "VLA 数据标注平台",
        shortName: "VLA Forge",
        accessibleName: "具身智能 VLA 数据标注平台",
        logoPath: "/logo.svg",
        loginTitle: "VLA Forge",
        ...sharedLoginPresentation,
        loginBackgroundImage: "/assets/login/embodied-data-production-hero-v1.jpg",
    },
    navigation: { menuKeys: sharedMenuKeys },
    features: sharedFeatures,
    api: { basePath: "/api/v2" },
});
export const westernProductConfig = defineProductConfig({
    code: "western",
    brand: {
        applicationName: westernApplicationName,
        platformName: "数据标注生产平台",
        shortName: "iLabel++",
        accessibleName: "西部创源数据标注平台",
        logoPath: "/logo.svg",
        loginTitle: "iLabel++",
        ...sharedLoginPresentation,
        loginBackgroundImage: "/assets/login/point-cloud-annotation-hero-v1.png",
    },
    navigation: { menuKeys: westernMenuKeys },
    features: sharedFeatures,
    api: { basePath: "/api/v2" },
});
export const productConfigs = Object.freeze({
    vla: vlaProductConfig,
    western: westernProductConfig,
});
export function getProductConfig(code) {
    return productConfigs[code];
}
//# sourceMappingURL=products.js.map